import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=c3663f8a&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=c3663f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3663f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3663f8a')) {
      api.createRecord('c3663f8a', component.options)
    } else {
      api.reload('c3663f8a', component.options)
    }
    module.hot.accept("./PersonalData.vue?vue&type=template&id=c3663f8a&scoped=true&", function () {
      api.rerender('c3663f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/SystemFieldForm/components/PersonalData.vue"
export default component.exports